import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "vehicle";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取车辆列表
    async getVehicleList({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingCarInfo/GetPage?${queryString.stringify(payload)}`
      );
      return result;
    },
    //新增/修改车辆
    async addOrUpdateVehicle({ commit }, payload) {
      let result = await api.post("/api/WeighingCarInfo/PostPC", payload);
      return result;
    },
    //获取单个车辆信息
    async getSingleView({ commit }, payload) {
      let result = await api.get(`/api/WeighingCarInfo/GetById?id=${payload}`);
      return result.data;
    },
    // 删除车辆
    async deleteVehicle({ commit }, payload) {
      let result = await api.delete(`/api/WeighingCarInfo/Delete/${payload}`);
      return result;
    },
    //获取车队列表
    async getCarTeamList({ commit }) {
      let result = await api.get(`/api/WeighingCarInfo/GetCarTeam`);
      return result.data;
    },

    //修改车队
    async editCarTeam({ commit }, payload) {
      let result = await api.put(
        `/api/WeighingCarInfo/Update?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //删除车队
    async deleteCarTeam({ commit }, payload) {
      let result = await api.delete(
        `/api/WeighingCarInfo/Delete?Id=${payload}`
      );
      return result.data;
    },

    //根据车队获取境外车信息--用于入境登记单
    async getGetCarInfo({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingCarInfo/GetCarInfo?carTeamId=${payload}`
      );
      return result.data;
    },
    //根据境外车信息获取车挂号
    async getFooterNum({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingCarInfo/GetFooterNum?carId=${payload}`
      );
      return result.data;
    },
  },
});

export default moduleName;
